import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MoreHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './button.js';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, } from './dropdown-menu.js';
function isAction(item) {
    return item !== 'separator';
}
/**
 * The "⋯" menu. Holds everything that is not the row's one inline action.
 * Destructive items are moved last, behind a separator, whatever order they
 * were given in.
 */
export function ActionsMenu({ items, variant = 'row', label, align = 'end', className }) {
    const { t } = useTranslation();
    const ordinary = items.filter((item) => !isAction(item) || !item.destructive);
    const destructive = items.filter((item) => isAction(item) && !!item.destructive);
    // Trim leading/trailing/double separators left by the split.
    const normalized = ordinary.filter((item, index, all) => {
        if (isAction(item))
            return true;
        const previous = all[index - 1];
        return index > 0 && index < all.length - 1 && previous !== 'separator';
    });
    const renderAction = (item, index) => (_jsxs(DropdownMenuItem, { disabled: item.disabled, destructive: item.destructive, onSelect: () => item.onSelect(), children: [item.icon && _jsx(item.icon, { "aria-hidden": "true" }), item.label] }, index));
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenuTrigger, { asChild: true, children: _jsx(Button, { variant: variant === 'row' ? 'ghost' : 'outline', size: variant === 'row' ? 'icon-sm' : 'icon', "aria-label": label ?? t('kit.moreActions'), className: className, children: _jsx(MoreHorizontal, { "aria-hidden": "true" }) }) }), _jsxs(DropdownMenuContent, { align: align, children: [normalized.map((item, index) => isAction(item) ? renderAction(item, index) : _jsx(DropdownMenuSeparator, {}, `separator-${index}`)), destructive.length > 0 && normalized.length > 0 && _jsx(DropdownMenuSeparator, {}), destructive.map((item, index) => renderAction(item, normalized.length + index))] })] }));
}
//# sourceMappingURL=actions-menu.js.map